import { useQueryClient } from "@tanstack/react-query";
import { FC, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  getListOrganizationsQueryKey,
  useListOrganizations,
} from "~/api/organizations/organizations";
import { Loader } from "~/components/Loader";
import { PageLayout } from "~/components/PageLayout";
import { ROUTES } from "~/helpers";

const RootContent: FC = () => {
  const navigate = useNavigate();
  const { data, error } = useListOrganizations();
  const queryClient = useQueryClient();

  useEffect(() => {
    const organizationId = data?.[0]?.id;
    if (organizationId) {
      navigate(ROUTES.CASES({ organizationId }));
    } else if (error) {
      if (error.code === 401) {
        queryClient.invalidateQueries({
          queryKey: getListOrganizationsQueryKey(),
        });
      }
    }
  }, [data, error, navigate, queryClient]);

  return (
    <PageLayout>
      <div className="flex flex-col items-center gap-2 h-[70vh] justify-center">
        <Loader>
          <div className="text-center mt-4">
            <FormattedMessage
              id="noOrganizations"
              defaultMessage="Please wait. If loading persists, <support>contact support</support>."
              values={{
                support: (chunks) => (
                  <a
                    href="mailto:support@usesky.ai"
                    className="text-blue-500 hover:underline"
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </div>
        </Loader>
      </div>
    </PageLayout>
  );
};

export const RootPage: FC = () => {
  return <RootContent />;
};
